import { render, staticRenderFns } from "./LevelUp.vue?vue&type=template&id=6d789e97&scoped=true"
import script from "./LevelUp.vue?vue&type=script&lang=js"
export * from "./LevelUp.vue?vue&type=script&lang=js"
import style0 from "./LevelUp.vue?vue&type=style&index=0&id=6d789e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d789e97",
  null
  
)

export default component.exports